import React from "react";
import { FleetPlateInfo, ButtonsContainer, ActionButton } from "./VehicleModalStyles";
import { TextField } from "@mui/material";
import { toReais } from "../../../../utils/functions";
import { VehicleFleet } from "../../../../types/vehicle.types";
import { Customer } from "../../../../types/customers.types";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { removeCamQueue } from "../../../../services/machineService";
import { useUnit } from "effector-react";
import { UserStore } from "../../../../stores/UserStore/UserStore";
import { toast } from "react-toastify";
import { AppError } from "../../../../services/classes";

interface Props {
  fleet?: VehicleFleet;
  client?: Customer;
  numberOfMachines: number;
  plate: string;
  updateList: () => void;
}

const FleetCard: React.FC<Props> = ({ fleet, client, numberOfMachines, plate, updateList }) => {
  const { station } = useUnit(UserStore);

  const clientName = fleet ? fleet.client.name : client?.name;
  const clientBalance = fleet ? fleet.client.balance : client?.balance ?? 0;
  const washingType = fleet ? fleet.washingType : client?.washingType;

  const handleActivate = (machine: string) => {
    setLoading(true);

    removeCamQueue({ station: station || "", plate, machine })
      .then(() => updateList())
      .catch((err: AppError) => {
        toast.error(err.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <FleetPlateInfo>
      {fleet && (
        <TextField
          fullWidth
          label="Frota"
          variant="outlined"
          value={fleet.description}
          size="small"
        />
      )}
      <TextField
        fullWidth
        label="Cliente"
        variant="outlined"
        value={clientName ?? ""}
        size="small"
      />
      <TextField
        fullWidth
        label="Saldo"
        variant="outlined"
        value={toReais(clientBalance)}
        size="small"
      />
      {washingType && (
        <TextField
          fullWidth
          label="Lavação"
          variant="outlined"
          value={`${washingType.name} - ${toReais(washingType.price)}`}
          size="small"
        />
      )}
      <ButtonsContainer>
        <ActionButton onClick={() => handleActivate("mach1")}>Acionar 1</ActionButton>
        {numberOfMachines > 1 && (
          <ActionButton onClick={() => handleActivate("mach2")}>Acionar 2</ActionButton>
        )}
      </ButtonsContainer>
    </FleetPlateInfo>
  );
};

export default FleetCard;
